import React from "react";

interface TextInputIconProps {}

export default function TextInputIcon(props: React.PropsWithChildren<TextInputIconProps>) {
  return <div className="min:w-6 flex h-6 items-center">{props.children}</div>;
}
